import React from 'react';

import {GenericPaginatedListRTK} from 'app/components/general/lists/GenericPaginatedListRTK';
import {useQuizzes} from 'app/quizzes/api';
import {CompactQuizListItem} from 'app/quizzes/components/QuizzesDashboard/CompactQuizListItem';
import {sweetAPI} from 'app/store/sweet-api';
import {useRemoveTeamItem} from 'app/teams/api';
import {
  type ListItemProps,
  TeamListItem,
} from 'app/teams/components/TeamDetailPage/components/TeamListItem';
import {TeamPageFilterBarStructure} from 'app/teams/components/TeamDetailPage/components/TeamPageFilterBarStructure';
import {DEFAULT_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';
import {useAsyncActions} from 'app/utils/redux';
import {QUIZ_TAGS} from 'app/utils/rtk-tags';

import {AddNewTeamQuizButton} from './AddNewTeamQuizButton';

import type {QuizSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  onFetch: () => unknown;
};

type QuizListItemProps = ListItemProps<QuizSerializedType> & {
  team: TeamSerializedType;
};

export const TeamQuizzesSubPage = ({team}: Props) => {
  const actions = useAsyncActions({
    invalidateTags: sweetAPI.util.invalidateTags,
  });

  const [removeTeamItem] = useRemoveTeamItem();
  const remove = (team: TeamSerializedType, item: QuizSerializedType) => {
    return removeTeamItem({
      teamURL: team.url,
      item,
    }).unwrap();
  };

  const refetchList = () => {
    // @ts-expect-error we inject tags on the API after it's created so TS doesn't know any tag type
    actions.invalidateTags([{type: QUIZ_TAGS.TAG, id: 'list'}]);
  };

  return (
    <div>
      {team.can_edit ? (
        <TeamPageFilterBarStructure>
          <div className="col-auto ml-auto">
            <AddNewTeamQuizButton team={team} />
          </div>
        </TeamPageFilterBarStructure>
      ) : null}

      <GenericPaginatedListRTK
        ItemComponent={QuizListItem}
        useQuery={useQuizzes}
        noItemsMessage={() => gt('No quizzes for this team')}
        paramsBuilder={() => ({
          team_id: team.id,
          ordering: 'name',
          page_size: DEFAULT_PAGE_SIZE,
        })}
        customProps={() => {
          return {
            remove,
            team,
            refetchList,
          };
        }}
      />
    </div>
  );
};

const QuizListItem = ({
  object,
  team,
  remove,
  refetchList,
}: QuizListItemProps) => (
  <TeamListItem
    object={object}
    team={team}
    remove={remove}
    contentType={'quiz'}
    ListItem={CompactQuizListItem}
    refetchList={refetchList}
  />
);
